import(/* webpackMode: "eager", webpackExports: ["ChatLoader"] */ "/app/app/chat/components/chat-loader.tsx");
